import {
  GET_ORDER_REQUEST,
  GET_ORDER_SUCCESS,
  GET_ORDER_FAIL,
  GET_ORDER_BY_ID_REQUEST,
  GET_ORDER_BY_ID_SUCCESS,
  GET_ORDER_BY_ID_FAIL,
  APPROVE_ORDER_REQUEST,
  APPROVE_ORDER_SUCCESS,
  APPROVE_ORDER_FAIL,
  MARK_PICKED_ORDER_REQUEST,
  MARK_PICKED_ORDER_SUCCESS,
  MARK_PICKED_ORDER_FAIL,
  ORDER_CANCEL_REQUEST,
  ORDER_CANCEL_SUCCESS,
  ORDER_CANCEL_FAIL,
  GET_ORDER_DELIVERED_REQUEST,
  GET_ORDER_DELIVERED_SUCCESS,
  GET_ORDER_DELIVERED_FAIL,
  SAVE_PICKUP_INFO,
  SAVE_PICKUP_INFO_ERROR,
  SAVE_DROPOFF_INFO,
  SAVE_DROPOFF_INFO_ERROR,
  SAVE_COURIER_INFO,
  SAVE_COURIER_INFO_ERROR,
  SAVE_PAYMENT_INFO,
  SAVE_PAYMENT_INFO_ERROR,
  PLACE_ORDER_REQUEST,
  PLACE_ORDER_SUCCESS,
  PLACE_ORDER_FAIL,
  MARK_DELIVERED_ORDER_REQUEST,
  MARK_DELIVERED_ORDER_SUCCESS,
  MARK_DELIVERED_ORDER_FAIL,
  GET_ORDER_ADMIN_REQUEST,
  GET_ORDER_ADMIN_SUCCESS,
  GET_ORDER_ADMIN_FAIL,
  SAVE_LENGTH,
  SAVE_HEIGTH,
  SAVE_WIDTH,
  SAVE_LHW_ERROR,
  GET_LAT_LONG,
  GET_LAT_LONG_ERROR,
  GET_DIRECTION_REQUEST,
  GET_DIRECTION,
  GET_DIRECTION_ERROR,
} from "../types/orderTypes";

export const orderReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_ORDER_REQUEST:
      return { loading: true };
    case GET_ORDER_SUCCESS:
      return { loading: false, orders: action.payload };
    case GET_ORDER_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const orderAdminReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_ORDER_ADMIN_REQUEST:
      return { loading: true };
    case GET_ORDER_ADMIN_SUCCESS:
      return { loading: false, orders: action.payload };
    case GET_ORDER_ADMIN_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const getOrderByIdReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_ORDER_BY_ID_REQUEST:
      return { loading: true };
    case GET_ORDER_BY_ID_SUCCESS:
      return { loading: false, order: action.payload };
    case GET_ORDER_BY_ID_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const approveOrderReducer = (state = {}, action) => {
  switch (action.type) {
    case APPROVE_ORDER_REQUEST:
      return { loading: true };
    case APPROVE_ORDER_SUCCESS:
      return { loading: false, approvedOrder: action.payload };
    case APPROVE_ORDER_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const markPickedOrderReducer = (state = {}, action) => {
  switch (action.type) {
    case MARK_PICKED_ORDER_REQUEST:
      return { loading: true };
    case MARK_PICKED_ORDER_SUCCESS:
      return { loading: false, markOrder: action.payload };
    case MARK_PICKED_ORDER_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const cancelOrderReducer = (state = {}, action) => {
  switch (action.type) {
    case ORDER_CANCEL_REQUEST:
      return { loading: true };
    case ORDER_CANCEL_SUCCESS:
      return { loading: false, cancOrder: action.payload };
    case ORDER_CANCEL_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const markDeliveredOrderReducer = (state = {}, action) => {
  switch (action.type) {
    case MARK_DELIVERED_ORDER_REQUEST:
      return { loading: true };
    case MARK_DELIVERED_ORDER_SUCCESS:
      return { loading: false, delOrder: action.payload };
    case MARK_DELIVERED_ORDER_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const getDeliveredOrderReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_ORDER_DELIVERED_REQUEST:
      return { loading: true };
    case GET_ORDER_DELIVERED_SUCCESS:
      return { loading: false, deliveredOrder: action.payload };
    case GET_ORDER_DELIVERED_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const savePickupInfoReducer = (state = {}, action) => {
  switch (action.type) {
    case SAVE_PICKUP_INFO:
      return { pickupInfo: action.payload };
    case SAVE_PICKUP_INFO_ERROR:
      return { error: action.payload };
    default:
      return state;
  }
};

export const saveDropoffInfoReducer = (state = {}, action) => {
  switch (action.type) {
    case SAVE_DROPOFF_INFO:
      return { dropoffInfo: action.payload };
    case SAVE_DROPOFF_INFO_ERROR:
      return { error: action.payload };
    default:
      return state;
  }
};

export const saveLengthReducer = (state = {}, action) => {
  switch (action.type) {
    case SAVE_LENGTH:
      return { length: action.payload };
    case SAVE_LHW_ERROR:
      return { error: action.payload };
    default:
      return state;
  }
};

export const saveHeigthReducer = (state = {}, action) => {
  switch (action.type) {
    case SAVE_HEIGTH:
      return { heigth: action.payload };
    case SAVE_LHW_ERROR:
      return { error: action.payload };
    default:
      return state;
  }
};

export const saveWidthReducer = (state = {}, action) => {
  switch (action.type) {
    case SAVE_WIDTH:
      return { width: action.payload };
    case SAVE_LHW_ERROR:
      return { error: action.payload };
    default:
      return state;
  }
};

export const saveCourierInfoReducer = (state = {}, action) => {
  switch (action.type) {
    case SAVE_COURIER_INFO:
      return { courierInfo: action.payload };
    case SAVE_COURIER_INFO_ERROR:
      return { error: action.payload };
    default:
      return state;
  }
};

export const savePaymentInfoReducer = (state = {}, action) => {
  switch (action.type) {
    case SAVE_PAYMENT_INFO:
      return { paymentInfo: action.payload };
    case SAVE_PAYMENT_INFO_ERROR:
      return { error: action.payload };
    default:
      return state;
  }
};

export const placeOrderReducer = (state = {}, action) => {
  switch (action.type) {
    case PLACE_ORDER_REQUEST:
      return { loading: true };
    case PLACE_ORDER_SUCCESS:
      return { loading: false, placeOrd: action.payload };
    case PLACE_ORDER_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const getLatLngReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_LAT_LONG:
      return { data: action.payload };
    case GET_LAT_LONG_ERROR:
      return { error: action.payload };
    default:
      return state;
  }
};

export const getDirectionReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_DIRECTION_REQUEST:
      return { loading: true };
    case GET_DIRECTION:
      return { loading: false, direction: action.payload };
    case GET_DIRECTION_ERROR:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};
